import React, { useEffect, useState } from "react";
import "../SellerCanceledOrders/SellerCanceledOrders.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import emptycart from "../../assets/empty-cart.png";

export default function SellerCanceledOrders() {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const fetchCanceledOrders = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BaseUrl}saller/all-my-orders?type=cancelled`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      setOrders(res?.data?.data ?? []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchCanceledOrders();
    }
  }, [token]);

  return (
    <div className="orders-page mt-5 pt-5 mobileorders">
      <div className="container mt-5">
        <div className="row">

          {/* ===== Left Tab (شكل ثابت بس للستايل) ===== */}
          <div className="col-lg-3 tabssection">
            <div className="orders-right-tabs">
              {/* <button className="cright-tab active">
                الطلبات الملغية
              </button> */}
            </div>
          </div>

          {/* ===== Cards ===== */}
          <div className="col-lg-9 col-12">
            <div className="cards-wrapper mt-5">

              {/* ===== Loader ===== */}
              {loading &&
                [1, 2, 3].map((i) => (
                  <div key={i} className="order-skeleton-card">
                    <div className="skeleton-lock"></div>
                    <div className="skeleton-middle">
                      <div className="skeleton-line short"></div>
                      <div className="skeleton-line medium"></div>
                    </div>
                    <div className="skeleton-right">
                      <div className="skeleton-badge"></div>
                      <div className="skeleton-line small"></div>
                    </div>
                  </div>
                ))}

              {/* ===== Empty State ===== */}
              {!loading && orders.length === 0 && (
                <div className="empty-orders text-center">
                  <img
                    src={emptycart}
                    alt="No orders"
                    className="empty-orders-image"
                  />
                  <h5 className="mt-3">لا توجد طلبات ملغية حالياً</h5>
                </div>
              )}

              {/* ===== Orders ===== */}
              {!loading &&
                orders.length > 0 &&
                orders.map((order) => (
                  <div
                    key={order.id || order.order_id}
                    className="order-card"
                    onClick={() =>
                      navigate(
                        `/seller/sellercanceledordersdetails/${
                          order.id || order.order_id
                        }`
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {/* Icon */}
                    <div className="order-icon">
                      <span className="lockicon">
                        <i className="fa fa-ban"></i>
                      </span>
                    </div>

                    {/* Center */}
                    <div className="order-center">
                      <h5 style={{ color: "red" }}>
                        طلب رقم {order.order_number}
                      </h5>
                      <span className="order-items">
                        {order.count_items || order.products?.length || 1} منتج
                      </span>
                    </div>

                    {/* Right */}
                    <div className="order-left">
                      <span className="order-status badge-cancel">
                        ملغية
                      </span>

                      <div className="comorder-price pt-4">
                        <span className="price-number">
                          {order.final_total || order.total}
                        </span>
                        <span className="price-currency"> ر.س</span>
                      </div>
                    </div>
                  </div>
                ))}

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}